<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12 pr-0">
          <v-btn class="btn-return mt-1" @click="handleBack"
            ><i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar</v-btn
          >
        </div>
        <div class="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-12">
          <h1 class="title-pages">FORMULÁRIO: {{ form.name }}</h1>
          <h6 class="worksansr">DESCRIÇÃO: {{ form.description }}</h6>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <v-expansion-panels accordion mandatory v-model="current_panel">
            <v-expansion-panel
              v-for="category in categories"
              :key="category.id"
              class="border"
            >
              <v-expansion-panel-header>
                <h6 class="mb-0 upper-text" style="text-align: left">
                  <span class="worksansr">CATEGORIA:</span> {{ category.name }}
                  <br />
                  <span class="worksansr text-thirteen"
                    >({{ category.questions.length }}
                    {{
                      category.questions.length > 1 ? "perguntas" : "pergunta"
                    }})</span
                  >
                </h6>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  class="row"
                  v-for="(question, question_index) in category.questions"
                  :key="question.id"
                >
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <h6>
                      {{ question_index + 1 }}. {{ question.statement }}
                      <span class="mandatory-data worksansr">
                        {{
                          question.mandatory == 1 ? "(Obrigatório)" : ""
                        }}</span
                      >
                    </h6>
                    <Open
                      v-if="
                        question.semiology_form_question_type_value == 'OPEN'
                      "
                      :question="question"
                      :category_id="category.id"
                      v-on:answer="handleChangeAnswerQuestions"
                    />
                    <Rating
                      v-if="
                        question.semiology_form_question_type_value == 'RATING'
                      "
                      :category_id="category.id"
                      :question="question"
                      v-on:answer="handleChangeAnswerQuestions"
                    />
                    <SingleChoice
                      v-if="
                        question.semiology_form_question_type_value ==
                        'SINGLE_CHOICE'
                      "
                      :category_id="category.id"
                      :question="question"
                      v-on:answer="handleChangeAnswerQuestions"
                    />
                    <MultipleChoice
                      v-if="
                        question.semiology_form_question_type_value ==
                        'MULTIPLE_CHOICE'
                      "
                      :category_id="category.id"
                      :question="question"
                      v-on:answer="handleChangeAnswerQuestions"
                    />
                    <Dichotomous
                      v-if="
                        question.semiology_form_question_type_value ==
                        'DICHOTOMOUS'
                      "
                      :category_id="category.id"
                      :question="question"
                      v-on:answer="handleChangeAnswerQuestions"
                    />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="text-right">
            <v-btn
              @click="answerQuestions"
              :disabled="loading"
              class="btn-save"
            >
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "SALVAR" }}</v-btn
            >
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../../services/api";

import Open from "./Question/Open";
import Rating from "./Question/Rating";
import SingleChoice from "./Question/SingleChoice";
import MultipleChoice from "./Question/MultipleChoice";
import Dichotomous from "./Question/Dichotomous";

import ErrorsMessages from "../../Components/ErrorsMessages";

import toast from "../../../lib/ToastNotification";

import routes from "../../../routes";

export default {
  name: "Form",
  components: {
    Open,
    Rating,
    SingleChoice,
    MultipleChoice,
    Dichotomous,
    ErrorsMessages,
  },
  created() {
    this.retrieve();
  },
  props: {
    form: Object,
  },
  data() {
    return {
      current_panel: 0,
      resident_id: "",
      categories: {},
      answer: [],
      errors: [],
      loading: false,
      MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
      DICHOTOMOUS: "DICHOTOMOUS",
      SINGLE_CHOICE: "SINGLE_CHOICE",
      RATING: "RATING",
      OPEN: "OPEN",
    };
  },
  methods: {
    handleBack() {
      this.$emit("clickBack");
    },
    handleChangeAnswerQuestions(e) {
      let { answer } = this;

      for (let item of answer) {
        if (item.category_id == e.category_id) {
          for (let question of item.questions) {
            if (question.id == e.id) {
              question.answer = e.answer;
              question.text = e.text;
            }
          }
        }
      }

      this.answer = answer;
    },
    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        let { form } = this;

        let params = { id: form.id };

        let response = await api.get("/rest-home/answer-semiology/form", {
          params,
        });

        let { error, errors, categories } = response.data;
        if (!error) {
          let answer = [];
          for (let category of categories) {
            let questions = [];
            for (let item of category.questions) {
              questions.push({
                id: item.id,
                mandatory: item.mandatory,
                statement: item.statement,
                semiology_form_question_type_value:
                  item.semiology_form_question_type_value,
              });
            }
            answer.push({
              category_id: category.id,
              category_name: category.name,
              questions,
            });
          }
          this.answer = answer;
          this.categories = categories;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async answerQuestions() {
      try {
        this.loading = true;

        const {
          resident_id,
          form: { id },
          answer,
        } = this;

        let params = {
          resident_id,
          id,
          answer,
        };

        const response = await api.post(
          "/rest-home/answer-semiology/form",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
